import * as config from "../config"
import getJamFilledCookie from "../getJamFilledCookie"
import fetch from "isomorphic-fetch"
import getUserIdFromLocalStorage from "../getUserIdFromLocalStorage"
import type { Comment } from "../../types"

export default async function reactToComment(
	JAM_ID: string,
	threadId: string,
	commentId: string,
	reactionEmoji: string,
	reactionAction: string,
): Promise<Comment | void> {
	try {
		const res = await fetch(
			`${config.API_HOSTNAME}/api/plugin/jam/${JAM_ID}/threads/${threadId}/comment/${commentId}`,
			{
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					"jam-filled-cookie": getJamFilledCookie(),
					"jam-filled-userid": getUserIdFromLocalStorage(),
				},
				body: JSON.stringify({
					// eslint-disable-next-line @typescript-eslint/camelcase
					reaction_emoji: reactionEmoji,
					// eslint-disable-next-line @typescript-eslint/camelcase
					reaction_action: reactionAction,
				}),
			},
		)

		const json = await res.json()

		return json.comment
	} catch (e) {
		console.log(e)
	}
}
